<template>
  <div class="formitem">
    <van-field
      v-model="industryText"
      is-link
      readonly
      :name="name"
      :label="field.text ? field.text : '所属行业'"
      :placeholder="field.place ? field.place : '请选择行业'"
      @click="industryShow = true"
      class="areabox"
      v-if="fieldShow"
    />
    <van-popup
      v-model:show="industryShow"
      round
      position="bottom"
      @click-overlay="onClickOverlay"
    >
      <!-- <van-tree-select
        v-model:main-active-index="activeIndex"
        v-model:active-id="activeId"
        :items="defaultItems"
        @click-nav="clickOne"
        @click-item="saveIndustry"
      >
      </van-tree-select> -->

      <van-picker
        title="行业"
        :columns="items"
        @confirm="saveIndustry"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, toRefs, watch } from "vue";
const props = defineProps({
  field: {
    type: Object,
    required: false,
  },
  defaultData: {
    required: false,
  },
  setData: {
    type: Function,
    required: false,
  },
  name: {
    type: String,
    required: false,
  },
  returnType: {
    type: String,
    required: false,
    default: "text", //id、text、both
  },
  fieldShow: {
    type: Boolean,
    required: false,
    default: true,
  },
  boxShow: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { field, name, returnType, defaultData, boxShow } = toRefs(props);
const industryShow = ref(false);
const industryText = ref(""); //比如KTv
const activeIndex = ref(0); //左侧下标
const activeId = ref(0); //右侧id,比如101
const result = ref("");
let items = []; //实际用到的配置

//默认配置
const defaultItems = [
  {
    text: "娱乐",
    id: 1,
    children: [
      {
        text: "KTV",
        id: 101,
        children: [
          { text: "咖啡厅", id: 201 },
          { text: "饮品店", id: 202 },
        ],
      },
      { text: "游戏厅", id: 102 },
    ],
  },
  {
    text: "休闲",
    id: 2,
    children: [
      { text: "咖啡厅", id: 201 },
      { text: "饮品店", id: 202 },
      { text: "健身馆", id: 203 },
      { text: "自助茶室", id: 204 },
      { text: "洗浴汗蒸", id: 205 },
    ],
  },
];

onMounted(() => {
  //配置
  if (
    field.value.value == undefined ||
    field.value.value == "" ||
    field.value.value == []
  ) {
    items = defaultItems;
  } else {
    items = field.value.value;
  }

  if (defaultData.value == "" || typeof defaultData.value == "undefined") {
    result.value = "";
  } else {
    industryText.value = defaultData.value;
    //默认的字段值
    let pregOk = false;
    let childIndustry, pregText;
    for (let i in items) {
      if (pregOk == true) {
        break;
      } //匹配成功则跳出循环

      if (items[i].children == undefined || items[i].children == []) {
        //无子级
        if (items[i].text == industryText.value) {
          //成功匹配左侧文字
          activeIndex.value = i; //左侧下标
          pregOk = true;
        }
      } else {
        //有子级
        childIndustry = items[i].children;
        for (let b in childIndustry) {
          pregText = childIndustry[b].text; //市名
          if (pregText == industryText.value) {
            //成功匹配右侧文字
            activeIndex.value = i; //左侧下标
            activeId.value = childIndustry[b].id; //右侧id
            pregOk = true;
            break;
          }
        }
      }
    }

    if (returnType.value == "id") {
      result.value = defaultData.value;
    } else if (returnType.value == "both") {
      industryText.value = defaultData.value;
      result.value = { text: defaultData.value, value: activeId.value };
    } else {
      result.value = industryText.value = defaultData.value;
    }
  }
});
//点击左侧菜单监听

const itemdata = ref(null)

const saveIndustry = (item) => {

  if(item[2].text !== ""){
    itemdata.value = item[2]
  }else if(item[1].text !== ""){
    itemdata.value = item[1]
  }else{
    itemdata.value = item[0]
  }

  if (returnType.value == "id") {
    result.value = itemdata.value.id;
  } else if (returnType.value == "both") {
    result.value = { text: itemdata.value.text, value: itemdata.value.id };
  } else {
    result.value = itemdata.value.text;
  }
  industryShow.value = false;
  industryText.value = itemdata.value.text;
  props.setData(name.value, result.value);
};
//点击右侧菜单监听
// const clickOne = (index) => {
//   console.log(index)
//   if (
//     typeof items[index].children == "undefined" ||
//     items[index].children.length == 0
//   ) {
//     if (returnType.value == "id") {
//       result.value = items[index].id;
//     } else if (returnType.value == "both") {
//       result.value = { text: items[index].text, value: items[index].id };
//     } else {
//       result.value = items[index].text;
//     }
//     industryShow.value = false;
//     industryText.value = items[index].text;
//     props.setData(name.value, result.value);
//   }
// };

const onCancel=()=>{
  industryShow.value = false;
  props.setData(name.value, "overlay");
}

const onClickOverlay = () => {
  industryShow.value = false;
  props.setData(name.value, "overlay");
};

///监听控制点击时展示地区弹窗
watch(boxShow, (newData) => {
  if (newData) {
    industryShow.value = true;
  } else {
    industryShow.value = false;
  }
});
</script>

<style lang="less" scoped>
.formitem {
  margin-bottom: 30px;
}
</style>
